import React from 'react';
import '../css/Footer.css'; 

import logo from '../assets/logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXTwitter, faDiscord, faTelegram } from '@fortawesome/free-brands-svg-icons';
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
            <h3><img src={logo} alt="Logo AI-DePIN" className="footer-logo" />AI-DePIN</h3>
        <ul className="footer-bottom">
        <li>&copy; 2024 AI-DePIN</li>
        <div className="footer-email">
        <li><a href="mailto:contact@ai-depin.org" target="_blank" rel="noopener noreferrer">contact@ai-depin.org</a></li>
        </div>
      </ul>
         
        </div>
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul className="quick-links">
            <li><a href="/roadmap">Roadmap</a></li>
            <li><a href="/tokenomics">Tokenomics</a></li>
            <li><a href="/wallet">Wallet</a></li>
            <li><a href="https://explorer.ai-depin.org" target="_blank" rel="noopener noreferrer">Explorer</a></li>
            <li><a href="https://ai-depin.gitbook.io/overview" target="_blank" rel="noopener noreferrer">Docs</a></li>
          </ul>
        </div>
        <div className="footer-section follow-us">
          <h3>Follow Us</h3>
          <ul className="social-links">
            <li>        <a href="https://x.com/AiDePIN_Org" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faXTwitter} className="social-icon" />
        </a></li>
            <li>        <a href="https://discord.gg/3HCqPzSsuZ" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faDiscord} className="social-icon" />
        </a></li>
            <li>        <a href="https://t.me/AIDP_Global" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faTelegram} className="social-icon" />
        </a></li>
          </ul>
        </div>
      </div>

    </footer>
  );
};

export default Footer;
